import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { Alert } from '@zillow/constellation';
import { dynamic } from '@zillow/frontier/dynamic';
import { remote } from '@zillow/frontier/import';
import React from 'react';
import { useBlockEnvironment } from '../components/BlockList/BlockEnvironment/BlockEnvironmentProvider.js';

var _excluded = ["attrs"];
/**
 * Creates a frontier block with standard configuration and behavior
 */
function createFrontierBlock(blockName, config) {
  // Validate block name format
  if (!blockName.includes('/')) {
    throw new Error('Block name must include a namespace (e.g., "cms-frontier/blockname" or "custom-namespace/block-name")');
  }
  var remoteModule = config.remoteModule,
    editorPlaceholder = config.editorPlaceholder;
  var blockMetadata = Object.assign({
    name: blockName
  }, config);
  var RemoteComponent = null;
  var createDynamicComponent = function createDynamicComponent() {
    {
      return dynamic(function () {
        return remote(remoteModule);
      }, {
        render: 'ssr',
        type: 'remote',
        module: remoteModule,
        webpack: function webpack() {
          return [require.resolve('@zillow/frontier/dynamic'), remoteModule];
        }
      });
    }
  };
  var BlockComponent = function BlockComponent(_ref) {
    var attrs = _ref.attrs,
      props = _objectWithoutProperties(_ref, _excluded);
    var _useBlockEnvironment = useBlockEnvironment(),
      environment = _useBlockEnvironment.environment;
    if (environment === 'editor') {
      return /*#__PURE__*/React.createElement(Alert, {
        body: editorPlaceholder || "Placeholder for " + config.title
      });
    }
    if (!RemoteComponent) {
      return null;
    }
    return /*#__PURE__*/React.createElement(RemoteComponent, _extends({}, attrs, props));
  };

  // Export standard block interface
  return {
    BLOCK_NAME: blockName,
    metadata: blockMetadata,
    register: function register(registry) {
      registry[blockName] = {
        Component: BlockComponent,
        metadata: blockMetadata
      };
    },
    initBlock: function initBlock() {
      RemoteComponent = createDynamicComponent();
    }
  };
}

export { createFrontierBlock };
